import type { ReactElement, SVGProps } from 'react'
import type { IconKey } from '../types/icons.types'
import { ChevronRightIcon } from './ChevronRightIcon'

export { ChevronRightIcon } from './ChevronRightIcon'

type IconProps = SVGProps<SVGSVGElement>

const defaultProps: IconProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false
}

export function SunburstIcon(props: IconProps) {
  return (
    <svg {...defaultProps} width={48} height={48} viewBox='0 0 48 48' {...props}>
      <path d='M24 6v4M24 38v4M6 24h4M38 24h4M11.5 11.5l2.8 2.8M33.7 33.7l2.8 2.8M11.5 36.5l2.8-2.8M33.7 14.3l2.8-2.8' />
      <circle cx='24' cy='24' r='8' />
      <path d='M24 12l2 6h6l-5 4 2 6-5-3.5L19 28l2-6-5-4h6l2-6z' fill='currentColor' stroke='none' opacity='0.25' />
    </svg>
  )
}

export function StarburstIcon(props: IconProps) {
  return (
    <svg {...defaultProps} width={48} height={48} viewBox='0 0 48 48' {...props}>
      <path
        d='M24 4l3.2 12.4L40 16l-10 7.2L33.6 36 24 28.8 14.4 36l3.6-12.8L8 16l12.8-.4L24 4z'
        fill='currentColor'
        stroke='currentColor'
        opacity='0.9'
      />
    </svg>
  )
}

export function ShieldIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M12 3l8 3v6c0 5-3.4 9.4-8 10.5C7.4 21.4 4 17 4 12V6l8-3z' />
      <path d='M9 12l2.2 2.2L15.5 10' />
    </svg>
  )
}

export function UsersIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='9' cy='8' r='3' />
      <circle cx='16' cy='9' r='2.5' />
      <path d='M3.5 19c1.2-3 3.2-4.5 5.5-4.5S13.3 16 14.5 19' />
      <path d='M14 14.5c1.6-.4 3.2.2 4.5 2.5' />
    </svg>
  )
}

export function CoinsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <ellipse cx='10' cy='8' rx='6' ry='3' />
      <path d='M4 8v5c0 1.7 2.7 3 6 3s6-1.3 6-3V8' />
      <path d='M14 10.5c1.8.3 4 1.3 4 2.8v4c0 1.7-2.7 3-6 3-1.2 0-2.3-.2-3.2-.5' />
    </svg>
  )
}

export function HniIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <rect x='4' y='10' width='16' height='10' rx='1.5' />
      <path d='M8 10V8a4 4 0 018 0v2' />
      <path d='M12 14v2' />
    </svg>
  )
}

export function FamilyIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='8' cy='7' r='2.5' />
      <circle cx='16' cy='7' r='2.5' />
      <path d='M3 19c.8-3 2.5-4.5 5-4.5s4.2 1.5 5 4.5' />
      <path d='M11 19c.8-3 2.5-4.5 5-4.5s4.2 1.5 5 4.5' />
    </svg>
  )
}

export function AdvisoryIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M12 3l7 3.5v5c0 4.2-2.8 7.8-7 9-4.2-1.2-7-4.8-7-9v-5L12 3z' />
      <path d='M9.5 12h5M12 9.5v5' />
    </svg>
  )
}

export function PowerRankIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M5 19V9M10 19V5M15 19v-7M20 19v-4' />
    </svg>
  )
}

export function RebalanceIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M4 12a8 8 0 0114.3-5' />
      <path d='M20 4v5h-5' />
      <path d='M20 12a8 8 0 01-14.3 5' />
      <path d='M4 20v-5h5' />
    </svg>
  )
}

export function PowerSelectIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='12' cy='12' r='8' />
      <path d='M12 8v8M8 12h8' />
    </svg>
  )
}

export function TaxIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <rect x='5' y='3' width='14' height='18' rx='2' />
      <path d='M9 8h6M9 12h6M9 16h4' />
    </svg>
  )
}

export function GlobalIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='12' cy='12' r='8' />
      <path d='M4.5 12h15M12 4.5c2.5 2.5 2.5 12.5 0 15M12 4.5c-2.5 2.5-2.5 12.5 0 15' />
    </svg>
  )
}

export function RegularToDirectIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M5 12h14' />
      <path d='M13 6l6 6-6 6' />
    </svg>
  )
}

export function EliteLessIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M12 4v16M7 9l5-5 5 5' />
    </svg>
  )
}

export function StrategyIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M4 18L10 8l4 6 6-10' />
    </svg>
  )
}

export function AllocationIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='12' cy='12' r='8' />
      <path d='M12 4v8l6 6' />
    </svg>
  )
}

export function SipIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <rect x='4' y='6' width='16' height='12' rx='2' />
      <path d='M8 10h8M8 14h5' />
    </svg>
  )
}

export function AdvisorSupportIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='12' cy='8' r='3' />
      <path d='M5 19c1.5-3.5 4-5 7-5s5.5 1.5 7 5' />
      <path d='M18 8h2M4 8h2M12 2v1' />
    </svg>
  )
}

export function RewardPointsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M12 3l2.4 7.2H22l-6 4.4 2.3 7.1L12 17.8 5.7 21.7 8 14.6 2 10.2h7.6L12 3z' />
    </svg>
  )
}

export function EliteLiveIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <rect x='3' y='6' width='18' height='12' rx='2' />
      <path d='M10 10l5 2-5 2v-4z' fill='currentColor' stroke='none' />
    </svg>
  )
}

export function InvestmentStrategyIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <path d='M4 19h16M7 16V9M12 16V5M17 16v-4' />
    </svg>
  )
}

export function RegistryChevronRightIcon(props: IconProps) {
  let size = 10
  if (typeof props.width === 'number') {
    size = props.width
  } else if (typeof props.height === 'number') {
    size = props.height
  }
  return <ChevronRightIcon size={size} color='currentColor' className={props.className} />
}

export function QuoteIcon(props: IconProps) {
  return (
    <svg {...defaultProps} width={28} height={28} viewBox='0 0 28 28' fill='currentColor' stroke='none' {...props}>
      <path d='M6 18.5c0-4.5 2.4-7.8 6.2-9.4L11 6C6.2 7.8 3 12.2 3 18.2 3 21.4 4.8 24 8.2 24c2.6 0 4.4-1.8 4.4-4.2 0-2.4-1.6-4-4-4.3-.9 0-1.7.1-2.6.1zm12 0c0-4.5 2.4-7.8 6.2-9.4L23 6c-4.8 1.8-8 6.2-8 12.2 0 3.2 1.8 5.8 5.2 5.8 2.6 0 4.4-1.8 4.4-4.2 0-2.4-1.6-4-4-4.3-.9 0-1.7.1-2.6.1z' />
    </svg>
  )
}

export function CheckReadyIcon({ fill, ...props }: IconProps & { fill?: string }) {
  return (
    <svg {...defaultProps} width={16} height={16} viewBox='0 0 16 16' {...props}>
      <circle cx='8' cy='8' r='7' fill={fill ?? '#E77464'} stroke='none' />
      <path d='M5 8l2 2 4-4' stroke='#fff' strokeWidth='1.5' />
    </svg>
  )
}

export function TrendUpIcon(props: IconProps) {
  return (
    <svg {...defaultProps} width={14} height={14} viewBox='0 0 14 14' {...props}>
      <path d='M3 9l4-4 4 4' />
    </svg>
  )
}

export function TrendDownIcon(props: IconProps) {
  return (
    <svg {...defaultProps} width={14} height={14} viewBox='0 0 14 14' {...props}>
      <path d='M3 5l4 4 4-4' />
    </svg>
  )
}

export function DefaultFeatureIcon(props: IconProps) {
  return (
    <svg {...defaultProps} {...props}>
      <circle cx='12' cy='12' r='8' />
      <path d='M12 8v8M8 12h8' />
    </svg>
  )
}

const ICON_REGISTRY: Record<string, (props: IconProps) => ReactElement> = {
  sunburst: SunburstIcon,
  starburst: StarburstIcon,
  shield: ShieldIcon,
  users: UsersIcon,
  coins: CoinsIcon,
  hni: HniIcon,
  family: FamilyIcon,
  advisory: AdvisoryIcon,
  powerRank: PowerRankIcon,
  rebalance: RebalanceIcon,
  powerSelect: PowerSelectIcon,
  tax: TaxIcon,
  global: GlobalIcon,
  regularToDirect: RegularToDirectIcon,
  eliteLess: EliteLessIcon,
  strategy: StrategyIcon,
  allocation: AllocationIcon,
  sip: SipIcon,
  advisorSupport: AdvisorSupportIcon,
  rewardPoints: RewardPointsIcon,
  eliteLive: EliteLiveIcon,
  investmentStrategy: InvestmentStrategyIcon,
  chevronRight: RegistryChevronRightIcon,
  quote: QuoteIcon,
  checkReady: CheckReadyIcon,
  trendUp: TrendUpIcon,
  trendDown: TrendDownIcon
}

export function ElitePlansIcon({ iconKey, ...props }: { iconKey: IconKey } & IconProps) {
  const Icon = ICON_REGISTRY[iconKey] ?? DefaultFeatureIcon
  return <Icon {...props} />
}
